export const theme = {
  colors: {
    primary: {
      dark: '#002C75',
      light: '#246ADF',
      default: '#0042B0',
      white: '#fff',
    },
    background: {
      dark: '#E5ECF7',
      light: '#F9FDFF',
    },
    error: {
      light: '#FFCABD',
      default: '#ff5630',
      dark: '#BF2600',
    },
    pending: {
      light: '#FFF0B3',
      default: '#F9A540',
      dark: '#FF8B00',
    },
    success: {
      light: '#C9F8E1',
      default: '#36B37E',
      dark: '#006644',
    },
    tag: [
      { dark: '#FFABAB', light: '#FFD8D8' },
      { dark: '#DA96DB', light: '#FEDDFF' },
      { dark: '#B493DE', light: '#DDC8F9' },
      { dark: '#A5C09B', light: '#D1E9C9' },
      { dark: '#4649D0', light: '#C0C2FF' },
    ],
    neutral: [
      '#F2F2F2',
      '#E5E5E5',
      '#CCCCCC',
      '#B3B3B3',
      '#999999',
      '#808080',
      '#666666',
      '#4C4C4C',
      '#333333',
      '#1A1A1A',
    ],
    black: '#000000',
    white: '#FFFFFF',
  },
  typography: {
    fonts: {
      size16: '1rem', // 16px
      size14: '0.875rem', // 14px
      size12: '0.75rem', //12px
      size10: '0.625rem', // 10px
      weight: {
        light: 300,
        regular: 400,
        medium: 500,
        bold: 600,
        extraBold: 700,
      },
      style: {
        normal: 'normal',
        italic: 'italic',
        oblique: 'oblique',
      },
      fontFamily: ['Arial', 'Helvetica', 'Helvetica Neue', 'sans-serif'],
    },
  },

  // shaping & spacing
  shape: { smallRadius: '4px', Radius: '8px', circularRadius: '50%' },

  orientations: {
    portrait: 'portrait',
    landscape: 'landscape',
  },

  breakpoints: {
    values: {
      xxss: 0, // extra extra small phone
      xxs: 568, // extra phone
      xs: 688, // phone
      sm: 768, // tablets
      md: 1280, // hd laptop
      lg: 1440, // fhd laptop
      xl: 2160, // 2k
      xxl: 2560, // 4k
    },
  },
};
